import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { connect } from 'react-redux';
import { AppState } from '../store/state/app.state';
import { IFooterProps } from '../types/propTypes/propTypes';
import { WithTranslation, withTranslation } from 'react-i18next';
const Footer = (props: IFooterProps & WithTranslation): JSX.Element => {
    return (
        <>
            <Navbar>
                <Nav navbar>
                    <Nav.Item></Nav.Item>
                </Nav>
            </Navbar>
            <footer className="footer">
                <div className="logo"></div>
                <p>
                    {`${props.t('footer.version')}: ${
                        props?.userData?.version_number_admin !== null ? props?.userData?.version_number_admin : ''
                    } | ${props.t('footer.copyRightText')}`}
                </p>
            </footer>
        </>
    );
};
const mapStateToProps = (state: AppState) => ({
    userData: state.UserData,
});

export default connect(mapStateToProps, null)(withTranslation()(Footer));
